import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { CONTRIBUTION_MODES } from '@lumapps/contents/constants';
import { getCurrentContributionMode } from '@lumapps/contents/ducks/selectors';
import { Theme, TextField } from '@lumapps/lumx/react';
import { ClickAwayProvider } from '@lumapps/lumx/react/utils';
import { useSelector } from '@lumapps/redux/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { CLASSNAME, EDITION_TITLE_TEXTAREA_CLASSNAME } from '../../../constants';

import './index.scss';

export interface EditableWidgetTitleProps {
    wrapperRef: React.MutableRefObject<null>;
    childrenRefs: React.MutableRefObject<React.MutableRefObject<null>[]>;
    exitEditionMode: (content: string) => void;
    content: string;
    onChange: React.Dispatch<React.SetStateAction<string>>;
    theme?: Theme;
}

export const EditableWidgetTitle: React.FC<EditableWidgetTitleProps> = ({
    wrapperRef,
    childrenRefs,
    exitEditionMode,
    content,
    onChange,
    theme = Theme.light,
}) => {
    const { translateKey } = useTranslate();
    const { element } = useClassnames(CLASSNAME);
    const contributionMode = useSelector(getCurrentContributionMode);

    return (
        <ClickAwayProvider
            callback={() => (contributionMode !== CONTRIBUTION_MODES.WRITER ? exitEditionMode(content) : undefined)}
            childrenRefs={childrenRefs}
        >
            <div className={element('editable-wrapper')}>
                <TextField
                    className={element(EDITION_TITLE_TEXTAREA_CLASSNAME)}
                    value={content}
                    placeholder={translateKey(GLOBAL.TITLE)}
                    onChange={onChange}
                    theme={theme}
                    multiline
                    ref={wrapperRef}
                    autoFocus
                />
            </div>
        </ClickAwayProvider>
    );
};
